import { MutationTree } from 'vuex';
import { ReportState } from '../stores/report.store';

export const mutationSetIsLoading = 'setIsLoading';
export const mutationSetShowAll = 'setShowAll';
export const mutationSetShowTeam = 'setShowTeam';

export const mutations: MutationTree<ReportState> = {
  [mutationSetIsLoading](state, payload: boolean) {
    state.isLoading = payload;
  },
  [mutationSetShowAll](state, payload: boolean) {
    state.showAll = payload;
  },
  [mutationSetShowTeam](state, payload: boolean) {
    state.showTeam = payload;
  },
};
